import vuex from 'vuex'
import Vue from 'vue'
import axios from 'axios';
import store from './index.js';
Vue.use(vuex)

// Store
const opcion = {
  state: {
    opciones: [],
    opciondefault : [],
    opcionarbol: []
  },
  actions: {
    get_porusuario({ commit }) {
      axios.get(`${process.env.VUE_APP_REST}/api/opcion/usuario`)
        .then(response => {          
          commit('SET_OPCION', response.data)
        })
        .catch(e => {          
          if  (e.response.status === 401)
          {
            store.dispatch("usuario/clean_usuario")
            axios.get(`${process.env.VUE_APP_REST}/api/opcion/publico/1`)
            .then(response => {
              commit('SET_OPCION', response.data)
            })
            .catch(e => {
              console.log(e.response)
              console.log(e.response.data)
            })            
          }         
        })
    }
    ,
    get_publico({ commit }) {
      axios.get(`${process.env.VUE_APP_REST}/api/opcion/publico/1`)
        .then(response => {
          commit('SET_OPCION', response.data)
        })
        .catch(e => {
          console.log(e.response)
          console.log(e.response.data)
        })
    },
    get_opciondefecto({ commit }) {
      axios.get(`${process.env.VUE_APP_REST}/api/opcion`)
        .then(response => {
          commit('SET_OPCIONDEFAULT', response.data)
        })
        .catch(e => {
          console.log(e.response)
          console.log(e.response.data)
        })
    },
    get_opciondarbol({ commit }) {
      axios.get(`${process.env.VUE_APP_REST}/api/opcion/GetOpciones` ).then(response => {
          commit('SET_OPCIONARBOL', response.data)
        })
        .catch(e => {
          console.log(e.response)
          console.log(e.response.data)
        })
    }
    ,
    cls_opciones({ commit }) {
      commit('SET_OPCION', [])
    }

  },
  mutations: {
    SET_OPCION(state, datos) {
      state.opciones = datos
    },
    SET_OPCIONDEFAULT(state, datos) {
      state.opciondefault = datos
    },
    SET_OPCIONARBOL(state, datos) {
      state.opcionarbol = datos
    }

  },
  getters: {
    gopciones(state) {
      return state.opciones;
    },
    gopciones_padre(state) {
      return state.opciones.filter(item => item.idopcionpadre === null);
    },
    gopcionesdefault(state){
      return state.opciondefault;
    },
    gopcionesarbol(state){
      return state.opcionarbol;
    }
  }
}

export default opcion;